import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ApiDataRoom, { DataRoomDTO } from '../../api/api-data-room';
import { StyledButton } from '../Shared/styled-button';
import ApiAnalytics from '../../api/api-analytics';

const Documents = () => {
    const [dataRoom, setDataRoom] = useState<DataRoomDTO | undefined>(undefined);
    const [dataRoomError, setDataRoomError] = useState<string | undefined>(undefined);

    useEffect(() => {
        ApiDataRoom.getDataRoom(1)
            .then((dataRoom) => {
                setDataRoom(dataRoom);
            })
            .catch((error) => {
                setDataRoomError(error.message);
            });
    }, []);

    if (dataRoomError) {
        return <Error>{dataRoomError}</Error>;
    }

    if (!dataRoom) {
        return <div>Loading...</div>;
    }

    return (
        <LinkContainer>
            {dataRoom.items.map((item) => {
                return (
                    <LinkButton
                        key={item.id}
                        onClick={() => {
                            window.open(item.link, '_blank');
                            ApiAnalytics.postAnalyticsEvent('Non US Investors', 'Opened Document', item.name);
                        }}
                    >
                        {item.name}
                    </LinkButton>
                );
            })}
        </LinkContainer>
    );
};

export default Documents;

const LinkContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
`;

const LinkButton = styled(StyledButton)``;

const Error = styled.p`
    color: white;
`;
